import React, { useEffect, useState } from 'react';
import Zoom from '@material-ui/core/Zoom';
import Paper from '@material-ui/core/Paper'
import ReactLoading from 'react-loading';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty } from '../utils/functions'
import FooterDelphus from '../components/FooterDelphus';
import FrTextInput from '../components/FrTextInput'
import FrLoading from '../components/FrLoading'
import logo from '../imgs/logo3.png'

import './styles/Pagamento.css';



const swal = withReactContent(Swal)

function Pagamento() {
  const [validHash, setValidHash] = useState(false)
  const [data, setData] = useState({})
  const [triggerZoom, setTriggerZoom] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      if (query.hash) {
        api.get('/linkPagSeguro?hash='+query.hash).then((res) => {
          if (res.data) {
            setData(res.data)
            setTimeout(() => {
              setValidHash(true)
            }, 500)
          } else {
            setTimeout(() => {
              swal.fire('Link inválido!', 'O link que você acessou é inválido ou expirou. Por favor, entre em contato conosco para solicitar um novo link.', 'error').then((result) => {
                window.location.href = 'https://www.ksaclube.com.br/'
              })
            }, 500)
          }
        })
       
      } else {
        setTimeout(() => {
          swal.fire('Link inválido!', 'O link que você acessou é inválido ou expirou. Por favor, entre em contato conosco para solicitar um novo link.', 'error').then((result) => {
            window.location.href = 'https://www.ksaclube.com.br/'
          })
        }, 1500)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    if (validHash){
      setTimeout(() => {
        setTriggerZoom(true)
      }, 500)
    }
  }, [validHash])

  const handleConfirm = (e) => {
    e.preventDefault()
    if (validHash && data) {
      swal.fire({
        html: <FrLoading text="Gerando Checkout PagSeguro..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.post('/geraLinkPagSeguro?hash='+data.HASH).then((res) => {
        if (res.status === 200) {
          swal.close()
          swal.fire({
            title: 'Confirmado!',
            text: "Clique abaixo para ser direcionado ao PagSeguro.",
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              window.location.href = res.data.url
            }
          })
        } else {
          swal.fire('Oops...', 'Ocorreu um erro inesperado', 'error')
        }
      })
    } else swal.fire('Oops...', 'Ocorreu um erro inesperado', 'error')
  } 


  return (
    <div className="Pagamento">
      <div className="Pagamento__wrapper">
      {!triggerZoom ? (
        <>
          <Zoom in={!validHash} timeout={500}>
            <Paper elevation={12} square>
              <div className="paperDiv">
                <div className="FrLoading">
                  <ReactLoading type="spin" color="#F1873B"/>
                  <p>Processando...</p>
                </div>
              </div>
            </Paper>
          </Zoom>
        </>) : 
        (<>
          <Zoom in={triggerZoom} timeout={500}>
            <Paper elevation={12} square>
              <div className="paperDiv">
                <div className="header">
                  <img alt="fr_logo" src={logo} title="KSA Clube" className="logo"/>
                  <div className="header-text">
                    <h1>Olá {data?.RAZAO_SOCIAL}!</h1>
                    <h2>Por favor, confirme os dados antes de prosseguir para o pagamento:</h2>
                  </div>
                </div>
                <div className="Pagamento__data">
                  <FrTextInput
                      maxLength='150'
                      name="plano"
                      id="plano"
                      color="#F1873B"
                      label="Plano"
                      variant="outlined"
                      size="small"
                      value={data?.NOMEPLA}
                      className="Pagamento__valor"
                      style={{ width: '100%', maxWidth: 500 }}
                      disabled={true}
                  />
                  <FrTextInput
                      maxLength='150'
                      name="parcela"
                      id="parcela"
                      color="#F1873B"
                      label="Parcela"
                      variant="outlined"
                      value={data?.PARCELA}
                      className="Pagamento__valor"
                      style={{ width: '100%', maxWidth: 80 }}
                      disabled={true}
                  />
                  <FrTextInput
                      maxLength='150'
                      name="valor"
                      id="valor"
                      color="#F1873B"
                      label="Valor"
                      variant="outlined"
                      size="small"
                      value={data?.VALOR?.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}
                      className="Pagamento__valor"
                      style={{ width: '100%', maxWidth: 100 }}
                      disabled={true}
                  />
                  
                </div>
                <div className="Pagamento__buttonsDiv">
                    <button onClick={handleConfirm}>Confirmar</button>
                </div>
                <footer className="Pagamento__footer">*Caso tenha alguma dúvida em relação aos dados acima, <a target="_blank" href="https://www.ksaclube.com.br/contato">entre em contato conosco.</a></footer>
              </div>
            </Paper>
          </Zoom>
        </>)} 

      </div>
      <FooterDelphus />
    </div>
  );
}

export default Pagamento;
